<template>

    <div>

        <Head :title="__('Dashboard')" />
        
        <div v-if="auth.user.role.slug == 'student'"  class="grid w-full grid-cols-1 gap-custom md:grid-cols-2 lg:grid-cols-3 ">
           
            <div 
                class="col-span-1 cursor-pointer card_height_c lg:col-span-1 xl:col-span-1 badge__item"
                @click="goToLink(this.route('tickets', { 'type': 'new' }))">
                <div class="flex items-center w-full h-full bg-white rounded-lg shadow-lg custom-panel">
                    <div class="flex-1 p-4 badge__info">
                        <span class="block mb-1 text-sm font-semibold text-gray-600 title">{{ __('New Tickets')
                            }}</span>
                        <span class="block text-xl font-bold text-gray-900 number">{{ new_tickets }}</span>
                    </div>
                    <div class="p-2 a__right">
                        <div class="flex items-center justify-center w-8 h-8 text-white rounded-full icon bg-success">
                            <i class="fa fa-bell" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div 
                class="col-span-1 cursor-pointer card_height_c lg:col-span-1 xl:col-span-1 badge__item"
                @click="goToLink(this.route('tickets', { 'type': 'open' }))">
                <div class="flex items-center w-full h-full bg-white rounded-lg shadow-lg custom-panel">
                    <div class="flex-1 p-4 badge__info">
                        <span class="block mb-1 text-sm font-semibold text-gray-600 title">{{ __('Open Tickets')
                            }}</span>
                        <span class="block text-xl font-bold text-gray-900 number">{{ opened_tickets }}</span>
                    </div>
                    <div class="p-2 a__right">
                        <div class="flex items-center justify-center w-8 h-8 text-white rounded-full icon bg-primary">
                            <i class="fa fa-envelope-open" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div 
                class="col-span-1 cursor-pointer card_height_c lg:col-span-1 xl:col-span-1 badge__item"
                @click="goToLink(this.route('tickets', { 'search': 'close' }))">
                <div class="flex items-center w-full h-full bg-white rounded-lg shadow-lg custom-panel">
                    <div class="flex-1 p-4 badge__info">
                        <span class="block mb-1 text-sm font-semibold text-gray-600 title">{{ __('Closed Tickets')
                            }}</span>
                        <span class="block text-xl font-bold text-gray-900 number">{{ closed_tickets }}</span>
                    </div>
                    <div class="p-2 a__right">
                        <div class="flex items-center justify-center w-8 h-8 text-white rounded-full icon bg-junk">
                            <i class="fa fa-envelope" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
         </div>

        <div v-if="auth.user.role.slug !== 'student'" class="grid w-full grid-cols-1 gap-custom md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
            <!-- Admin -->
            <div 
                class="col-span-1 cursor-pointer card_height_c lg:col-span-1 xl:col-span-1 badge__item"
                @click="goToLink(this.route('tickets', { 'type': 'new' }))">
                <div class="flex items-center w-full h-full bg-white rounded-lg shadow-lg custom-panel">
                    <div class="flex-1 p-4 badge__info">
                        <span class="block mb-1 text-sm font-semibold text-gray-600 title">{{ __('New Tickets')
                            }}</span>
                        <span class="block text-xl font-bold text-gray-900 number">{{ new_tickets }}</span>
                    </div>
                    <div class="p-2 a__right">
                        <div class="flex items-center justify-center w-8 h-8 text-white rounded-full icon bg-success">
                            <i class="fa fa-bell" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="col-span-1 cursor-pointer card_height_c lg:col-span-1 xl:col-span-1 badge__item"
                @click="goToLink(this.route('tickets', { 'type': 'open' }))">
                <div class="flex items-center w-full h-full bg-white rounded-lg shadow-lg custom-panel">
                    <div class="flex-1 p-4 badge__info">
                        <span class="block mb-1 text-sm font-semibold text-gray-600 title">{{ __('Open Tickets')
                            }}</span>
                        <span class="block text-xl font-bold text-gray-900 number">{{ opened_tickets }}</span>
                    </div>
                    <div class="p-2 a__right">
                        <div class="flex items-center justify-center w-8 h-8 text-white rounded-full icon bg-primary">
                            <i class="fa fa-envelope-open" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div 
                class="col-span-1 cursor-pointer card_height_c lg:col-span-1 xl:col-span-1 badge__item"
                @click="goToLink(this.route('tickets', { 'search': 'close' }))">
                <div class="flex items-center w-full h-full bg-white rounded-lg shadow-lg custom-panel">
                    <div class="flex-1 p-4 badge__info">
                        <span class="block mb-1 text-sm font-semibold text-gray-600 title">{{ __('Closed Tickets')
                            }}</span>
                        <span class="block text-xl font-bold text-gray-900 number">{{ closed_tickets }}</span>
                    </div>
                    <div class="p-2 a__right">
                        <div class="flex items-center justify-center w-8 h-8 text-white rounded-full icon bg-junk">
                            <i class="fa fa-envelope" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div 
                class="col-span-1 cursor-pointer card_height_c lg:col-span-1 xl:col-span-1 badge__item"
                @click="goToLink(this.route('tickets', { 'type': 'un_assigned' }))">
                <div class="flex items-center w-full h-full bg-white rounded-lg shadow-lg custom-panel">
                    <div class="flex-1 p-4 badge__info">
                        <span class="block mb-1 text-sm font-semibold text-gray-600 title">{{ __('Unassigned Tickets')
                            }}</span>
                        <span class="block text-xl font-bold text-gray-900 number">{{ un_assigned_tickets }}</span>
                    </div>
                    <div class="p-2 a__right">
                        <div class="flex items-center justify-center w-8 h-8 text-white rounded-full icon bg-cold">
                            <i class="fa fa-flag" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="col-span-1 cursor-pointer card_height_c lg:col-span-1 xl:col-span-1 badge__item"
                @click="goToLink(this.route('users'))">
                <div class="flex items-center w-full h-full bg-white rounded-lg shadow-lg custom-panel">
                    <div class="flex-1 p-4 badge__info">
                        <span class="block mb-1 text-sm font-semibold text-gray-600 title">{{ __('All Students')
                            }}</span>
                        <span class="block text-xl font-bold text-gray-900 number">{{ total_customer }}</span>
                    </div>
                    <div class="p-2 a__right">
                        <div class="flex items-center justify-center w-8 h-8 text-white rounded-full icon bg-danger">
                            <i class="fa fa-users" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div 
                class="col-span-1 cursor-pointer card_height_c lg:col-span-1 xl:col-span-1 badge__item"
                @click="goToLink(this.route('contacts'))">
                <div class="flex items-center w-full h-full bg-white rounded-lg shadow-lg custom-panel">
                    <div class="flex-1 p-4 badge__info">
                        <span class="block mb-1 text-sm font-semibold text-gray-600 title">{{ __('All Contacts')
                            }}</span>
                        <span class="block text-xl font-bold text-gray-900 number">{{ total_contacts }}</span>
                    </div>
                    <div class="p-2 a__right">
                        <div class="flex items-center justify-center w-8 h-8 text-white rounded-full icon bg-warning">
                            <i class="fa fa-users" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Student Graph -->
        <div v-if="auth.user.role.slug == 'student'"
            class="grid grid-cols-1 gap-5 mt-5 response__details sm:grid-cols-1 md:grid-cols-12">
            <div class="col-span-12 md:col-span-6">
                <div class="shadow-sm custom_card custom-card">
                    <div class="custom-card-header ">
                        <h5 class="mb-0 fw-bold">{{ __('Ticket by Status') }} ({{ count_tickets_by_status }}) </h5>
                    </div>
                    <div class="card-body">
                        <div class="pt-3">
                            <MyNewChartComponent :department-data="top_statuses"
                                style="height: 270px !important; width: 430px !important; height: 315px !important; user-select: none;" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-span-12 md:col-span-6">
                <div class="shadow-sm custom_card custom-card">
                    <div class="custom-card-header ">
                        <h5 class="mb-0 fw-bold">{{ __('Department Ticket Assigned') }} </h5>
                    </div>
                    <div class="card-body">
                        <div class="pt-3">
                            <ReportBarChart :series-data="bar_chart_dept_series" :categories="bar_chart_dept_categories"
                                style="height: 270px !important;    width: 430px !important; height: 315px !important; user-select: none;" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- Admin Graph -->


        <div v-if="auth.user.role.slug !== 'student'"
            class="grid grid-cols-1 gap-5 mt-5 response__details sm:grid-cols-1 md:grid-cols-12">

            <div class="col-span-12 md:col-span-6">
                <div class="shadow-sm custom_card custom-card">
                    <div class="custom-card-header ">
                        <h5 class="mb-0 fw-bold">
                            {{ __('Ticket by Departments') }} ({{ count_tickets_by_department }})
                        </h5>
                    </div>
                    <div class="card-body">
                        <div class="pt-3">
                            <MyNewChartComponent :department-data="top_departments"
                                :style="{ height: '315px', width: '100%', userSelect: 'none' }" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-span-12 md:col-span-6">
                <div class="shadow-sm custom_card custom-card">
                    <div class="custom-card-header ">
                        <h5 class="mb-0 fw-bold">{{ __('Department Ticket Assigned') }} </h5>
                    </div>
                    <div class="card-body">
                        <div class="pt-3">
                            <ReportBarChart :series-data="bar_chart_dept_series" :categories="bar_chart_dept_categories"
                                style="height: 270px !important;    width: 430px !important; height: 315px !important; user-select: none;" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="auth.user.role.slug !== 'student'"
            class="grid grid-cols-1 gap-5 mt-5 response__details sm:grid-cols-1 md:grid-cols-12">

            <div class="col-span-12 md:col-span-6">
                <div class="shadow-sm custom_card custom-card">
                    <div class="custom-card-header ">
                        <h5 class="mb-0 fw-bold">{{ __('Ticket by Status') }} ({{ count_tickets_by_status }}) </h5>
                    </div>
                    <div class="card-body">
                        <div class="pt-3">
                            <MyNewChartComponent :department-data="top_statuses"
                                style="height: 270px !important; width: 430px !important; height: 315px !important; user-select: none;" />
                        </div>
                    </div>
                </div>
            </div>



            <div class="col-span-12 md:col-span-6">
                <div class="shadow-sm custom_card custom-card">
                    <div class="custom-card-header ">
                        <h5 class="mb-0 fw-bold">{{ __('Status Ticket Assigned') }} </h5>
                    </div>
                    <div class="card-body">
                        <div class="pt-3">
                            <ReportBarChart :series-data="bar_chart_status_series"
                                :categories="bar_chart_status_categories"
                                style="height: 270px !important;    width: 430px !important; height: 315px !important; user-select: none;" />
                        </div>
                    </div>
                </div>
            </div>


        </div>

        <div class="grid grid-cols-1 gap-5 mt-5 response__details sm:grid-cols-1 md:grid-cols-12"
            v-if="auth.user.role.slug !== 'student'">

            <div class="w-full col-span-12 md:col-span-12" style=" margin-bottom: 20px;">
                <div class="flex flex-col p-5 bg-white rounded-lg shadow-lg r__wrapper rd">
                    <h2 class="pt-3 text-lg font-bold th__ttl">{{ __('Ticket history') }}</h2>
                    <div class="flex th__info">
                        <span class="text-xl font-bold"> {{ chart_line.this_month }} </span>
                        <span class="pt-2 pl-1 pr-1 text-xs">/ {{ __('this month') }}</span>
                        <span class="pt-2 pl-2 pr-2 text-xs font-bold">{{ __('last month') }} {{
                            chart_line.last_month }}</span>
                    </div>
                    <div v-if="months.length" class="flex justify-center w-full c__wrapper ">
                        <div class="flex flex-col items-center w-full gap-3 c__line" v-for="cl in months">
                            <span class="cl__b" :style="{ '--cl_value': cl.value }"></span>
                            <span class="text-xs cl__n">{{ cl.month }}</span>
                        </div>
                    </div>
                </div>
            </div>







        </div>


        <!-- Loading Process -->
        <div v-if="loading" class="processing-overlay">
            <div class="background"></div>
            <div class="loader">
                <svg width="200px" height="200px" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"
                    style="background: none;">
                    <circle cx="75" cy="50" fill="#ffffff" r="6.39718">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="-0.875s"></animate>
                    </circle>
                    <circle cx="67.678" cy="67.678" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="-0.75s"></animate>
                    </circle>
                    <circle cx="50" cy="75" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="-0.625s"></animate>
                    </circle>
                    <circle cx="32.322" cy="67.678" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="-0.5s"></animate>
                    </circle>
                    <circle cx="25" cy="50" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="-0.375s"></animate>
                    </circle>
                    <circle cx="32.322" cy="32.322" fill="#ffffff" r="4.80282">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="-0.25s"></animate>
                    </circle>
                    <circle cx="50" cy="25" fill="#ffffff" r="6.40282">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="-0.125s"></animate>
                    </circle>
                    <circle cx="67.678" cy="32.322" fill="#ffffff" r="7.99718">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s"
                            repeatCount="indefinite" begin="0s"></animate>
                    </circle>
                </svg>
            </div>
        </div>
        <!-- Loading Process -->

    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import VueApexCharts from '@/Shared/donut/t_tickets'
import BarChartComponent from '@/Shared/barchart/t_report_tickets'
import MyNewChartComponent from '@/Shared/barchart/mynewchart'
import ReportBarChart from '@/Shared/barchart/reportbarchart'

export default {
    metaInfo: { title: 'Dashboard' },
    components: {
        Head,
        Icon,
        Link,
        VueApexCharts,
        BarChartComponent,
        MyNewChartComponent,
        ReportBarChart,
    },
    layout: Layout,
    props: {
        auth: Object,
        entries: Array,
        chart_line: Object,
        api_key: String,
        new_tickets: Number,
        total_tickets: Number,
        un_assigned_tickets: Number,
        opened_tickets: Number,
        closed_tickets: Number,
        first_response: Array,
        top_creators: Array,
        last_response: Array,
        top_departments: Array,
        top_statuses: Array,
        count_tickets_by_department: Number,
        count_tickets_by_status: Number,
        top_categories: Array,
        top_types: Array,
        total_customer: Number,
        total_contacts: Number,
        department_assignee_bar_chart_data: Object,
        status_assignee_bar_chart_data: Object,
        bar_chart_dept_categories: Array,
        bar_chart_dept_series: Array,
        bar_chart_status_series: Array,
        bar_chart_status_categories: Array,
    },
    data() {
        return {
            errors: [],
            loading: false,
            firstResponse: [],
            lastResponse: [],
            months: []
        }
    },


    created() {

        for (let i = 0; i < this.first_response.length; i++) {
            if (i % 2 === 0) {
                this.firstResponse = [...this.firstResponse, [this.first_response[i], this.first_response[i + 1]]]
            }
        }
        for (let i = 0; i < this.last_response.length; i++) {
            if (i % 2 === 0) {
                this.lastResponse = [...this.lastResponse, [this.last_response[i], this.last_response[i + 1]]]
            }
        }

        this.months = this.chart_line.previousMonths.map(m => {
            return { 'month': m, 'value': this.chart_line.months[m] ? ((this.chart_line.months[m] * 100) / this.chart_line.total) + '%' : '0%' }
        })
    },
    methods: {
        goToLink(link) {
            window.location.href = link;
        },
    },
}
</script>
